import axios from '../../axios'

// 新增相似专业
export const addSameprof = (data) => {
    return axios({
        url: '/api/data/wish/school/same/prof',
        method: 'POST',
        data
    })
}

// 修改相似专业
export const editSameprof = (data) => {
    return axios({
        url: '/api/data/wish/school/same/prof',
        method: 'PUT',
        data
    })
}

// 获取相似专业详情
export const getSameprof = (data) => {
    return axios({
        url: '/api/data/wish/school/same/prof',
        method: 'GET',
        data
    })
}

// 删除相似专业
export const deleteSameprof = (data) => {
    return axios({
        url: '/api/data/wish/school/same/prof',
        method: 'DELETE',
        data
    })
}

// 获取相似专业列表
export const getSameprofList = (data) => {
    return axios({
        url: '/api/data/wish/school/same/prof',
        method: 'GET',
        data
    })
}

// 导入相似专业
export const importSameprof = (data) => {
    return axios({
        url: '/api/data/wish/school/same/prof/import',
        method: 'POST',
        data
    })
}

// 导出相似专业
export const exportSameprof = (data) => {
    return axios({
        url: '/api/data/wish/school/same/prof/export',
        method: 'POST',
        data
    })
}

// 批量更新相似专业
export const updateSameprof = (data) => {
    return axios({
        url: '/api/data/wish/school/same/prof/batch/update',
        method: 'POST',
        data
    })
}

// 批量删除相似专业
export const allDeleteSameprof = (data) => {
    return axios({
        url: '/api/data/wish/school/same/prof/batch/delete',
        method: 'POST',
        data
    })
}

// 初始化相似专业数据
export const initSameprofData = (data) => {
    return axios({
        url: '/api/data/wish/school/same/prof/school/init',
        method: 'POST',
        data
    })
}

// 同步标签 SchoolId
export const handleSameprofTabBySchoolId = (data) => {
    return axios({
        url: '/api/data/wish/school/same/prof/school/sync',
        method: 'POST',
        data
    })
}

// 同步标签 dataId
export const handleSameprofTabById = (data) => {
    return axios({
        url: '/api/data/wish/school/same/prof/id/sync',
        method: 'POST',
        data
    })
}

// 获取相似专业日志记录
export const getSameprofLog = (data) => {
    return axios({
        url: '/api/data/wish/school/same/prof/log',
        method: 'GET',
        data
    })
}

// 对比比较相似专业日志记录
export const handleCompareSameprofLog = (data) => {
    return axios({
        url: '/api/data/wish/school/same/prof/log/compare',
        method: 'POST',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/sameprof.js